import React from "react";
import ManageProject from "../../super_admin/manage/project/Main";

const Show = ({ org_id, project_id }) => {
  return <ManageProject org_id={org_id} project_id={project_id} member_mode={true} />;
};

export default Show;
